// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cargo-input-number[data-v-6247f488]  .el-input-number__increase.is-disabled,\n.cargo-input-number[data-v-6247f488]  .el-input-number__decrease.is-disabled {\n  pointer-events: none;\n}\n.cargo-input-number.empty-if-zero[data-v-6247f488]  .el-input-number__decrease {\n  pointer-events: none;\n  color: #cccccc;\n}\n", ""]);
// Exports
module.exports = exports;
